var _rect, _path, _path2, _path3, _g, _path4, _path5, _g2, _path6, _g3, _path7, _path8, _g4, _path9, _path0, _g5, _path1, _path10, _g6, _path11, _g7, _path12, _path13, _g8, _path14, _path15, _g9, _path16, _path17, _g0, _path18, _g1, _path19, _path20, _g10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIceberg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 407,
    height: 400,
    viewBox: "0 0 407 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    width: 400,
    height: 400,
    rx: 62.5,
    fill: "#FFDF00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.54 222H45.07C43.88 222 43.25 221.37 43.25 220.18V174.82C43.25 173.49 43.88 173 45.07 173H53.54C54.87 173 55.43 173.49 55.43 174.82V220.18C55.43 221.51 54.87 222 53.54 222ZM107.245 207.58C107.805 207.16 108.295 206.95 108.645 206.95C109.135 206.95 109.415 207.23 109.905 207.79L113.895 213.53C114.175 213.95 114.315 214.37 114.315 214.72C114.315 215.14 113.965 215.7 113.265 216.33C108.225 220.53 101.855 222.91 94.9253 222.91C80.2953 223.12 68.6053 211.99 68.8853 197.78C68.6753 183.15 80.2953 171.88 95.4853 172.09C102.415 172.09 108.575 174.54 113.545 178.67C114.105 179.16 114.385 179.58 114.385 180C114.385 180.35 114.245 180.77 113.895 181.26L109.835 187C109.415 187.63 108.995 187.91 108.505 187.91C108.085 187.91 107.595 187.7 107.105 187.35C103.325 184.62 99.4053 183.29 95.4153 183.29C87.3653 183.29 81.4853 189.1 81.4853 197.57C81.4853 205.76 87.3653 211.71 95.4153 211.71C99.6853 211.71 103.675 210.31 107.245 207.58ZM160.091 212.62V220.18C160.091 221.37 159.461 222 158.201 222H128.731C127.541 222 126.911 221.37 126.911 220.18V174.82C126.911 173.49 127.541 173 128.731 173H158.131C159.391 173 160.021 173.63 160.021 174.82V182.38C160.021 183.71 159.461 184.2 158.131 184.2H140.141C139.301 184.2 139.091 184.48 139.091 185.25V190.71C139.091 191.55 139.301 191.76 140.141 191.76H155.821C157.151 191.76 157.641 192.32 157.641 193.65V201.14C157.641 202.33 157.151 202.96 155.821 202.96H140.141C139.301 202.96 139.091 203.24 139.091 204.01V209.75C139.091 210.52 139.301 210.8 140.141 210.8H158.201C159.531 210.8 160.091 211.29 160.091 212.62ZM175.893 173H194.233C206.483 173 212.853 177.06 212.853 186.65C212.853 191.41 210.473 194.84 206.763 196.59C211.453 197.99 214.393 201.98 214.393 207.02C214.393 217.38 207.113 222 194.443 222H175.893C174.703 222 174.073 221.37 174.073 220.18V174.82C174.073 173.49 174.703 173 175.893 173ZM186.253 184.69V190.92C186.253 191.69 186.463 191.97 187.303 191.97H193.533C198.363 191.97 200.393 190.78 200.393 187.77C200.393 184.76 198.363 183.64 193.533 183.64H187.303C186.463 183.64 186.253 183.92 186.253 184.69ZM201.793 206.95C201.793 203.87 199.413 202.61 194.443 202.61H187.303C186.463 202.61 186.253 202.82 186.253 203.66V210.31C186.253 211.08 186.463 211.36 187.303 211.36H194.443C199.553 211.36 201.793 210.03 201.793 206.95ZM260.5 212.62V220.18C260.5 221.37 259.87 222 258.61 222H229.14C227.95 222 227.32 221.37 227.32 220.18V174.82C227.32 173.49 227.95 173 229.14 173H258.54C259.8 173 260.43 173.63 260.43 174.82V182.38C260.43 183.71 259.87 184.2 258.54 184.2H240.55C239.71 184.2 239.5 184.48 239.5 185.25V190.71C239.5 191.55 239.71 191.76 240.55 191.76H256.23C257.56 191.76 258.05 192.32 258.05 193.65V201.14C258.05 202.33 257.56 202.96 256.23 202.96H240.55C239.71 202.96 239.5 203.24 239.5 204.01V209.75C239.5 210.52 239.71 210.8 240.55 210.8H258.61C259.94 210.8 260.5 211.29 260.5 212.62ZM284.772 222H276.302C275.112 222 274.482 221.37 274.482 220.18V174.82C274.482 173.49 275.112 173 276.302 173H292.332C306.962 173 314.102 178.25 314.102 189.45C314.102 195.33 311.372 199.6 305.842 202.26L316.552 219.76C316.902 220.25 317.042 220.67 317.042 221.02C317.042 221.65 316.482 222 315.292 222H306.192C304.232 222 303.602 221.65 302.552 219.9L291.352 200.44C291.282 200.37 290.932 199.67 290.932 199.32C290.932 198.83 291.422 198.55 292.332 198.41C297.722 197.78 301.502 195.19 301.502 190.64C301.502 185.88 298.282 183.64 292.052 183.64H287.712C286.872 183.64 286.662 183.85 286.662 184.69V220.18C286.662 221.51 286.102 222 284.772 222ZM370.836 218.15C364.676 221.23 358.516 222.91 351.586 222.91C337.026 223.12 325.406 212.62 325.616 197.99C325.406 182.66 337.026 171.88 352.216 172.09C359.216 172.09 365.516 174.19 370.486 177.62C371.256 178.11 371.676 178.67 371.676 179.23C371.676 179.72 371.536 180.14 371.186 180.63L367.616 186.16C367.126 186.93 366.706 187.21 366.076 187.21C365.726 187.21 365.236 187.07 364.746 186.79C360.686 184.48 356.486 183.29 352.216 183.29C343.676 183.29 338.216 189.38 338.216 197.64C338.216 206.04 343.886 211.85 351.866 211.85C354.736 211.85 357.186 211.43 359.286 210.66C360.126 210.31 360.336 210.03 360.336 209.12V199.25C360.336 197.92 360.826 197.36 362.156 197.36H370.696C372.026 197.36 372.516 197.92 372.516 199.25V215.42C372.516 216.89 372.166 217.52 370.836 218.15Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M353 223.25V230C353 234.418 349.418 238 345 238H248C243.582 238 240 234.418 240 230V223.25V222",
    stroke: "#09A2E3",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M237.333 224.7C237.333 226.173 238.527 227.367 240 227.367C241.473 227.367 242.667 226.173 242.667 224.7C242.667 223.227 241.473 222.034 240 222.034C238.527 222.034 237.333 223.227 237.333 224.7ZM240 224.7H239.5V225.7H240H240.5V224.7H240Z",
    fill: "#09A2E3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3494_15163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.333 224.7C237.333 226.173 238.527 227.367 240 227.367C241.473 227.367 242.667 226.173 242.667 224.7C242.667 223.227 241.473 222.034 240 222.034C238.527 222.034 237.333 223.227 237.333 224.7ZM240 224.7H239.5V225.7H240H240.5V224.7H240Z",
    fill: "#09A2E3"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M237.333 224.7C237.333 226.173 238.527 227.367 240 227.367C241.473 227.367 242.667 226.173 242.667 224.7C242.667 223.227 241.473 222.034 240 222.034C238.527 222.034 237.333 223.227 237.333 224.7ZM240 224.7H239.5V225.7H240H240.5V224.7H240Z",
    fill: "#09A2E3",
    fillOpacity: 0.45
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M238.667 224.7C238.667 225.437 239.264 226.034 240 226.034C240.736 226.034 241.333 225.437 241.333 224.7C241.333 223.964 240.736 223.367 240 223.367C239.264 223.367 238.667 223.964 238.667 224.7ZM240 224.7H239.75V225.7H240H240.25V224.7H240Z",
    fill: "#09A2E3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3494_15163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236 224.7C236 226.909 237.791 228.7 240 228.7C242.209 228.7 244 226.909 244 224.7C244 222.491 242.209 220.7 240 220.7C237.791 220.7 236 222.491 236 224.7ZM240 224.7H239.25V225.7H240H240.75V224.7H240Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M350.333 224.7C350.333 226.173 351.527 227.367 353 227.367C354.473 227.367 355.667 226.173 355.667 224.7C355.667 223.227 354.473 222.034 353 222.034C351.527 222.034 350.333 223.227 350.333 224.7ZM353 224.7H352.5V225.7H353H353.5V224.7H353Z",
    fill: "#09A2E3"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3494_15163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.333 224.7C350.333 226.173 351.527 227.367 353 227.367C354.473 227.367 355.667 226.173 355.667 224.7C355.667 223.227 354.473 222.034 353 222.034C351.527 222.034 350.333 223.227 350.333 224.7ZM353 224.7H352.5V225.7H353H353.5V224.7H353Z",
    fill: "#09A2E3"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M350.333 224.7C350.333 226.173 351.527 227.367 353 227.367C354.473 227.367 355.667 226.173 355.667 224.7C355.667 223.227 354.473 222.034 353 222.034C351.527 222.034 350.333 223.227 350.333 224.7ZM353 224.7H352.5V225.7H353H353.5V224.7H353Z",
    fill: "#09A2E3",
    fillOpacity: 0.45
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M351.667 224.7C351.667 225.437 352.264 226.034 353 226.034C353.736 226.034 354.333 225.437 354.333 224.7C354.333 223.964 353.736 223.367 353 223.367C352.264 223.367 351.667 223.964 351.667 224.7ZM353 224.7H352.75V225.7H353H353.25V224.7H353Z",
    fill: "#09A2E3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_3494_15163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349 224.7C349 226.909 350.791 228.7 353 228.7C355.209 228.7 357 226.909 357 224.7C357 222.491 355.209 220.7 353 220.7C350.791 220.7 349 222.491 349 224.7ZM353 224.7H352.25V225.7H353H353.75V224.7H353Z",
    fill: "white"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M292 171.75V165C292 160.582 288.418 157 284 157H102C97.5817 157 94 160.582 94 165V171.75V173",
    stroke: "#09A2E3",
    strokeWidth: 2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3333 170.3C91.3333 168.827 92.5272 167.633 94 167.633C95.4728 167.633 96.6667 168.827 96.6667 170.3C96.6667 171.773 95.4728 172.966 94 172.966C92.5272 172.966 91.3333 171.773 91.3333 170.3ZM94 170.3H93.5V169.3H94H94.5V170.3H94Z",
    fill: "#09A2E3"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_3494_15163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.3333 170.3C91.3333 168.827 92.5272 167.633 94 167.633C95.4728 167.633 96.6667 168.827 96.6667 170.3C96.6667 171.773 95.4728 172.966 94 172.966C92.5272 172.966 91.3333 171.773 91.3333 170.3ZM94 170.3H93.5V169.3H94H94.5V170.3H94Z",
    fill: "#09A2E3"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3333 170.3C91.3333 168.827 92.5272 167.633 94 167.633C95.4728 167.633 96.6667 168.827 96.6667 170.3C96.6667 171.773 95.4728 172.966 94 172.966C92.5272 172.966 91.3333 171.773 91.3333 170.3ZM94 170.3H93.5V169.3H94H94.5V170.3H94Z",
    fill: "#09A2E3",
    fillOpacity: 0.45
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6667 170.3C92.6667 169.563 93.2636 168.966 94 168.966C94.7364 168.966 95.3333 169.563 95.3333 170.3C95.3333 171.036 94.7364 171.633 94 171.633C93.2636 171.633 92.6667 171.036 92.6667 170.3ZM94 170.3H93.75V169.3H94H94.25V170.3H94Z",
    fill: "#09A2E3"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_3494_15163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90 170.3C90 168.091 91.7909 166.3 94 166.3C96.2091 166.3 98 168.091 98 170.3C98 172.509 96.2091 174.3 94 174.3C91.7909 174.3 90 172.509 90 170.3ZM94 170.3H93.25V169.3H94H94.75V170.3H94Z",
    fill: "white"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M289.333 170.3C289.333 168.827 290.527 167.633 292 167.633C293.473 167.633 294.667 168.827 294.667 170.3C294.667 171.773 293.473 172.966 292 172.966C290.527 172.966 289.333 171.773 289.333 170.3ZM292 170.3H291.5V169.3H292H292.5V170.3H292Z",
    fill: "#09A2E3"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_3494_15163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.333 170.3C289.333 168.827 290.527 167.633 292 167.633C293.473 167.633 294.667 168.827 294.667 170.3C294.667 171.773 293.473 172.966 292 172.966C290.527 172.966 289.333 171.773 289.333 170.3ZM292 170.3H291.5V169.3H292H292.5V170.3H292Z",
    fill: "#09A2E3"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M289.333 170.3C289.333 168.827 290.527 167.633 292 167.633C293.473 167.633 294.667 168.827 294.667 170.3C294.667 171.773 293.473 172.966 292 172.966C290.527 172.966 289.333 171.773 289.333 170.3ZM292 170.3H291.5V169.3H292H292.5V170.3H292Z",
    fill: "#09A2E3",
    fillOpacity: 0.45
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M290.667 170.3C290.667 169.563 291.264 168.966 292 168.966C292.736 168.966 293.333 169.563 293.333 170.3C293.333 171.036 292.736 171.633 292 171.633C291.264 171.633 290.667 171.036 290.667 170.3ZM292 170.3H291.75V169.3H292H292.25V170.3H292Z",
    fill: "#09A2E3"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_3494_15163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288 170.3C288 168.091 289.791 166.3 292 166.3C294.209 166.3 296 168.091 296 170.3C296 172.509 294.209 174.3 292 174.3C289.791 174.3 288 172.509 288 170.3ZM292 170.3H291.25V169.3H292H292.75V170.3H292Z",
    fill: "white"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M190 223.25V230C190 234.418 186.418 238 182 238H57C52.5817 238 49 234.418 49 230V223.25V222",
    stroke: "#09A2E3",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3333 224.7C46.3333 226.173 47.5272 227.367 49 227.367C50.4728 227.367 51.6667 226.173 51.6667 224.7C51.6667 223.227 50.4728 222.034 49 222.034C47.5272 222.034 46.3333 223.227 46.3333 224.7ZM49 224.7H48.5V225.7H49H49.5V224.7H49Z",
    fill: "#09A2E3"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_3494_15163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.3333 224.7C46.3333 226.173 47.5272 227.367 49 227.367C50.4728 227.367 51.6667 226.173 51.6667 224.7C51.6667 223.227 50.4728 222.034 49 222.034C47.5272 222.034 46.3333 223.227 46.3333 224.7ZM49 224.7H48.5V225.7H49H49.5V224.7H49Z",
    fill: "#09A2E3"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3333 224.7C46.3333 226.173 47.5272 227.367 49 227.367C50.4728 227.367 51.6667 226.173 51.6667 224.7C51.6667 223.227 50.4728 222.034 49 222.034C47.5272 222.034 46.3333 223.227 46.3333 224.7ZM49 224.7H48.5V225.7H49H49.5V224.7H49Z",
    fill: "#09A2E3",
    fillOpacity: 0.45
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6667 224.7C47.6667 225.437 48.2636 226.034 49 226.034C49.7364 226.034 50.3333 225.437 50.3333 224.7C50.3333 223.964 49.7364 223.367 49 223.367C48.2636 223.367 47.6667 223.964 47.6667 224.7ZM49 224.7H48.75V225.7H49H49.25V224.7H49Z",
    fill: "#09A2E3"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_3494_15163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 224.7C45 226.909 46.7909 228.7 49 228.7C51.2091 228.7 53 226.909 53 224.7C53 222.491 51.2091 220.7 49 220.7C46.7909 220.7 45 222.491 45 224.7ZM49 224.7H48.25V225.7H49H49.75V224.7H49Z",
    fill: "white"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M187.333 224.7C187.333 226.173 188.527 227.367 190 227.367C191.473 227.367 192.667 226.173 192.667 224.7C192.667 223.227 191.473 222.034 190 222.034C188.527 222.034 187.333 223.227 187.333 224.7ZM190 224.7H189.5V225.7H190H190.5V224.7H190Z",
    fill: "#09A2E3"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_3494_15163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.333 224.7C187.333 226.173 188.527 227.367 190 227.367C191.473 227.367 192.667 226.173 192.667 224.7C192.667 223.227 191.473 222.034 190 222.034C188.527 222.034 187.333 223.227 187.333 224.7ZM190 224.7H189.5V225.7H190H190.5V224.7H190Z",
    fill: "#09A2E3"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M187.333 224.7C187.333 226.173 188.527 227.367 190 227.367C191.473 227.367 192.667 226.173 192.667 224.7C192.667 223.227 191.473 222.034 190 222.034C188.527 222.034 187.333 223.227 187.333 224.7ZM190 224.7H189.5V225.7H190H190.5V224.7H190Z",
    fill: "#09A2E3",
    fillOpacity: 0.45
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M188.667 224.7C188.667 225.437 189.264 226.034 190 226.034C190.736 226.034 191.333 225.437 191.333 224.7C191.333 223.964 190.736 223.367 190 223.367C189.264 223.367 188.667 223.964 188.667 224.7ZM190 224.7H189.75V225.7H190H190.25V224.7H190Z",
    fill: "#09A2E3"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_3494_15163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186 224.7C186 226.909 187.791 228.7 190 228.7C192.209 228.7 194 226.909 194 224.7C194 222.491 192.209 220.7 190 220.7C187.791 220.7 186 222.491 186 224.7ZM190 224.7H189.25V225.7H190H190.75V224.7H190Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3494_15163",
    x: 191.333,
    y: 176.034,
    width: 97.3333,
    height: 97.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23,
    result: "effect1_foregroundBlur_3494_15163"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3494_15163",
    x: 231,
    y: 215.7,
    width: 18,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_3494_15163"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3494_15163",
    x: 304.333,
    y: 176.034,
    width: 97.3333,
    height: 97.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23,
    result: "effect1_foregroundBlur_3494_15163"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_3494_15163",
    x: 344,
    y: 215.7,
    width: 18,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_3494_15163"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_3494_15163",
    x: 45.3334,
    y: 121.633,
    width: 97.3333,
    height: 97.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23,
    result: "effect1_foregroundBlur_3494_15163"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_3494_15163",
    x: 85,
    y: 161.3,
    width: 18,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_3494_15163"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_3494_15163",
    x: 243.333,
    y: 121.633,
    width: 97.3333,
    height: 97.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23,
    result: "effect1_foregroundBlur_3494_15163"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_3494_15163",
    x: 283,
    y: 161.3,
    width: 18,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_3494_15163"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_3494_15163",
    x: 0.333374,
    y: 176.034,
    width: 97.3333,
    height: 97.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23,
    result: "effect1_foregroundBlur_3494_15163"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_3494_15163",
    x: 40,
    y: 215.7,
    width: 18,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_3494_15163"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_3494_15163",
    x: 141.333,
    y: 176.034,
    width: 97.3333,
    height: 97.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23,
    result: "effect1_foregroundBlur_3494_15163"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_3494_15163",
    x: 181,
    y: 215.7,
    width: 18,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_3494_15163"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIceberg);
export default __webpack_public_path__ + "static/media/Iceberg.91369a6b179b45ca599b2e199496811f.svg";
export { ForwardRef as ReactComponent };